(() => {
  const ROOT_SELECTOR = '[data-sm-native-product-gallery="true"]';

  function cleanupLegacyGallery(root) {
    root.querySelectorAll('.sm-product-gallery__thumbs, .sm-product-gallery__arrow')
      .forEach((element) => element.remove());

    root.querySelectorAll('.sm-product-gallery').forEach((gallery) => {
      gallery.classList.remove('sm-product-gallery');
      gallery.dataset.smCompactGallery = 'true';
    });

    root.querySelectorAll('.sm-product-gallery__stage')
      .forEach((stage) => stage.classList.remove('sm-product-gallery__stage'));
  }

  function initializeTabs(root) {
    const tabs = [...root.querySelectorAll('[data-sm-native-tab]')];
    const panels = [...root.querySelectorAll('[data-sm-native-panel]')];
    if (!tabs.length || !panels.length) return;

    const activate = (name, focus = false) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.smNativeTab === name;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.smNativePanel !== name;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.smNativeTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        activate(tabs[nextIndex].dataset.smNativeTab, true);
      });
    });

    activate(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true')?.dataset.smNativeTab || tabs[0].dataset.smNativeTab);
  }

  function initializeGalleryArrows(root) {
    root.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.smNativeArrowsReady === 'true') return;
      const mediaItems = [...gallery.querySelectorAll('[id^="Slider-Gallery-"] > [data-media-id]')];
      const previous = gallery.querySelector('[data-sm-gallery-previous]');
      const next = gallery.querySelector('[data-sm-gallery-next]');
      if (mediaItems.length < 2 || !previous || !next || typeof gallery.setActiveMedia !== 'function') return;

      const move = (direction) => {
        const current = Math.max(0, mediaItems.findIndex((item) => item.classList.contains('is-active')));
        const target = mediaItems[(current + direction + mediaItems.length) % mediaItems.length];
        gallery.setActiveMedia(target.dataset.mediaId, false);
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      gallery.dataset.smNativeArrowsReady = 'true';
    });
  }

  function hideInkColorOnProductPage(root) {
    root.querySelectorAll('variant-radios fieldset, variant-selects .product-form__input')
      .forEach((field) => {
        const label = field.querySelector('legend, .form__label, label')?.textContent
          ?.replace(/\s+/g, ' ')
          .trim()
          .toLocaleLowerCase('de-DE') || '';
        if (label.includes('stempelfarbe') || label.includes('kissenfarbe')) {
          field.hidden = true;
          field.dataset.smConfiguratorOnly = 'true';
        }
      });
  }

  function initialize(root) {
    if (!root || root.dataset.smProductPageReady === 'true') return;
    root.dataset.smProductPageReady = 'true';
    cleanupLegacyGallery(root);
    initializeTabs(root);
    initializeGalleryArrows(root);
    if (root.dataset.smIndividualProduct === 'true') {
      hideInkColorOnProductPage(root);
    }

    const observer = new MutationObserver(() => cleanupLegacyGallery(root));
    observer.observe(root, { childList: true, subtree: true });
  }

  function initializeAll(scope = document) {
    if (scope.matches?.(ROOT_SELECTOR)) initialize(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
